module.exports = __webpack_public_path__ + "static/media/share-icon.be819872.svg";